import { Component, OnDestroy, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CustomDate } from 'app/core/helpers/format-date-helper';
import { SweetAlertHelper } from 'app/core/helpers/sweet-alert-helper.service';
import { ToastrAlertHelper } from 'app/core/helpers/toastr-alert-helper-service';
import { IPosted } from 'app/core/interfaces/deposit.interface';
import { IPostedEdit, IPostedEditPayload } from 'app/core/interfaces/posted.interface';
import { ConciliationService } from 'app/core/services/conciliation.service';
import { T2LoadingService } from 'app/trip2-theme/components/t2-loading/t2-loading.service';
import { Subscription } from 'rxjs/Subscription';
import { finalize } from 'rxjs/operators';

@Component({
  selector: 'app-edit-posted',
  templateUrl: './edit-posted.component.html',
  styleUrls: ['./edit-posted.component.scss'],
})
export class EditPostedComponent implements OnInit, OnDestroy {
  postedCrudForm: FormGroup;
  subscriptions: Subscription[] = [];
  constructor(
    private fb: FormBuilder,
    private t2LoadingService: T2LoadingService,
    protected objServ: ConciliationService,
    private objToast: ToastrAlertHelper,
    private sweetAlertHelper: SweetAlertHelper,
    private conciliationService: ConciliationService
  ) {
    this.subscriptions.push(
      this.conciliationService.postedEdit$.subscribe((params: IPostedEditPayload) => {
        if (params && params.action === 'postedEdit') {
          this.setterData(params.postedEdit);
        }
      })
    );
  }

  ngOnInit() {
    this.createForm();
  }

  getCtrlByName(controlName: string): AbstractControl {
    if (!this.postedCrudForm) { return; }
    return  this.postedCrudForm.get(controlName);
  }

  clearControlCrud(controlName: string, value = ''): void {
    this.postedCrudForm.get(controlName).patchValue(value);
  }

  setterData(params: IPostedEdit): void {
    if (this.postedCrudForm && params && params.id) {
      const formatDate = 'yyyy-MM-dd';
      const postedDate = CustomDate.formatJs(params.posteddate, formatDate);
      const checkDate = CustomDate.formatJs(params.checkdate, formatDate);
      const depositDate = CustomDate.formatJs(params.depositdate, formatDate);


      this.getCtrlByName('id').patchValue(params.id);
      this.getCtrlByName('payor').patchValue(params.payor);
      this.getCtrlByName('amtpaid').patchValue(params.amtpaid);
      this.getCtrlByName('posteddate').patchValue(postedDate);
      this.getCtrlByName('checkdate').patchValue(checkDate);
      this.getCtrlByName('checknumber').patchValue(params.checknumber);
      this.getCtrlByName('depositdate').patchValue(depositDate);
      this.getCtrlByName('rcsql').patchValue(params.rcsql);
      this.getCtrlByName('company').patchValue(params.company);
      this.getCtrlByName('depositid').patchValue(params.depositid);
      this.getCtrlByName('exportcode').patchValue(params.exportcode);
      this.getCtrlByName('batch').patchValue(params.batch);
      this.getCtrlByName('importedon').patchValue(params.importedon);
      this.getCtrlByName('importorigin').patchValue(params.importorigin);
      this.getCtrlByName('postedstatusid').patchValue(params.postedstatusid);
      this.getCtrlByName('credittypecode').patchValue(params.credittypecode);
    }
  }

  saveChanges(): void {
    if (this.postedCrudForm.valid) {
      this.t2LoadingService.show();
      const formData = this.postedCrudForm.getRawValue();
      formData.payor = formData.payor ? formData.payor.trim() : null;
      formData.checknumber = formData.checknumber
        ? formData.checknumber.trim()
        : null;
      formData.rcsql = formData.rcsql ? formData.rcsql.trim() : null;
      formData.company = formData.company ? formData.company.trim() : null;
      formData.depositid =
        formData.depositid && !isNaN(Number(formData.depositid))
          ? Number(formData.depositid)
          : null;
      formData.amtpaid =
        formData.amtpaid && !isNaN(Number(formData.amtpaid))
          ? Number(formData.amtpaid)
          : null;

      formData.exportcode =
        formData.exportcode && !isNaN(Number(formData.exportcode))
          ? Number(formData.exportcode)
          : null;
      formData.batch =
        formData.batch && !isNaN(Number(formData.batch))
          ? Number(formData.batch)
          : null;

      const req: IPosted = Object.assign({}, formData);
      this.subscriptions.push(
        this.objServ
          .updatePosted(req)
          .pipe(finalize(() => this.t2LoadingService.hiden()))
          .subscribe({
            next: (resp: any) => {
              if (resp) {
                this.sweetAlertHelper.createCustomAlert({
                  title: resp.message,
                  type: 'success',
                });

                this.setterData(resp.data);
                this.conciliationService.setPostedEdit('closePostedEditAndRefresh', null);
              }
            },
            error: (er) => this.sweetAlertHelper.captureException(er),
          })
      );
    } else {
      this.objToast.error('Form incomplete', '', {
        positionClass: 'toast-bottom-right',
      });
    }
  }

  closeModal() {
    this.conciliationService.setPostedEdit('closePostedEdit', null);
  }

  createForm(): void {
    this.postedCrudForm = this.fb.group({
      id: null,
      payor: [null, Validators.required],
      amtpaid: [null, Validators.required],
      posteddate: [null, Validators.required],
      checkdate: [null, Validators.required],
      checknumber: [null, Validators.required],
      depositdate: [null, Validators.required],
      rcsql: null,
      company: [null, Validators.required],
      depositid: null,
      exportcode: null,
      batch: null,
      importedon: null,
      importorigin: null,
      postedstatusid: null,
      credittypecode: [null, Validators.required]
    });
  }

  ngOnDestroy() {
    if (this.subscriptions && this.subscriptions.length) {
      this.subscriptions.map((subscribe: Subscription) =>
        subscribe.unsubscribe()
      );
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/billing-general/deposits/posted/edit-posted/edit-posted.component.ts